// components/Modal.jsx
import React from "react";
import ReactModal from "react-modal";
import "./Modal.css"; // 아래 스타일 파일 생성

ReactModal.setAppElement('#root');

export function Modal({ visible, onClose, changePage, hostName }) {
  const menuItems = [
    {
      id: 'useTimeDetail',
      title: '커미션 명세서',
      icon: 'fas fa-file-invoice-dollar',
      description: '상세한 수입 분석을 확인하세요',
      color: 'primary'
    },
    {
      id: 'showMeTheMoney',
      title: '실시간 메소 확인',
      icon: 'fas fa-coins',
      description: '실시간 수입 현황을 모니터링하세요',
      color: 'success'
    },
    {
      id: 'showMeTheNeso',
      title: '실시간 네소 확인',
      icon: 'fas fa-coins',
      description: '실시간 네소 수입 현황을 모니터링하세요',
      color: 'warning'
    },
    {
      id: 'useTime',
      title: '사용 시간 순위',
      icon: 'fas fa-clock',
      description: 'PC 사용 시간을 분석하세요',
      color: 'info'
    },
    {
      id: 'stigmaStatus',
      title: '찍 상태 확인',
      icon: 'fas fa-shield-alt',
      description: '디바이스 찍 상태를 확인하세요',
      color: 'warning'
    }
  ];

  return (
    <ReactModal
      isOpen={visible}
      onRequestClose={onClose}
      contentLabel="페이지 선택"
      className="modern-modal-container"
      overlayClassName="modern-modal-overlay"
      shouldCloseOnOverlayClick={true}
    >
      <div className="modern-modal-content">
        <div className="modal-header-section">
          <div className="modal-title-area">
            <h2 className="modal-title">
              <i className="fas fa-desktop me-2"></i>
              {hostName}
            </h2>
            <p className="modal-subtitle">원하는 기능을 선택해주세요</p>
          </div>
          <button className="modal-close-btn" onClick={onClose}>
            <i className="fas fa-times"></i>
        </button>
        </div>
        
        <div className="modal-body-section">
          <div className="menu-grid">
            {menuItems.map((item) => (
              <div 
                key={item.id}
                className={`menu-card ${item.color}`}
                onClick={() => changePage(item.id)}
              >
                <div className="menu-icon">
                  <i className={item.icon}></i>
                </div>
                <div className="menu-content">
                  <h3 className="menu-title">{item.title}</h3>
                  <p className="menu-description">{item.description}</p>
                </div>
                <div className="menu-arrow">
                  <i className="fas fa-chevron-right"></i>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </ReactModal>
  );
}
